<template>
  <v-layout>
    <v-flex xs12 NewEditDeleteDialog>
      <v-dialog v-model="dialog" persistent :fullscreen="!$vuetify.breakpoint.md && !$vuetify.breakpoint.lg" max-width="1400">
        <v-card :loading="loading">
          <v-card-title :class="`font-weight-bold`" style="font-size:22px;">
            <v-toolbar
              color="primary"
              dark
              absolute
              dense>
              <div>categories
                <span class="font-weight-light">view</span>
              </div>
              <v-spacer></v-spacer>
              <v-btn  flat @click.native="closeDialog()" >
                <v-icon class="hidden-md-and-up">close</v-icon>
                <span class="hidden-sm-and-down">cancel</span>
              </v-btn>
            </v-toolbar>
          </v-card-title>
          <v-card-text class="mt-3">
            <v-layout row wrap>
              <v-flex xs12 v-for="(r, i) in resource" :key="'resource-'+i">
                <div style="font-size:18px;font-weight:bold;">
                  {{ r.name }}
                  <v-btn color="primary" :loading="loading" small flat @click="edit(r)">edit</v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props:['dialog', 'loading', 'resource'],
  data() {
    return {
      
    }
  },
  methods:{
    closeDialog() {
      this.$emit('closeDialog')
    },
    edit(r) {
      this.$emit('editCategory', r)
    },
  }
}
</script>